export default __webpack_public_path__ + "static/media/249.1487bfef.jpg";